import axios from 'axios'
import {
    ARTICELS_LIST_REQUEST,
    ARTICELS_LIST_REQUEST_SUCCESS,
    ARTICELS_LIST_REQUEST_FAIL,
    ARTICEL_REQUEST,
    ARTICEL_REQUEST_SUCCESS,
    ARTICEL_REQUEST_FAIL,
    ADMIN_ARTICEL_REQUEST,
    ADMIN_ARTICEL_REQUEST_SUCCESS,
    ADMIN_ARTICEL_REQUEST_FAIL,
} from './articlesConstants'

export const listArticels = (lang, pageNumber = 1, keyword = '', mainCategoryId = 0) => async (dispatch) => {
    try {
        dispatch({ type: ARTICELS_LIST_REQUEST })
        let adr = '/api/articles/?lan=' + lang
        if (pageNumber > 0)
            adr += '&page=' + pageNumber

        if (keyword !== '') {
            adr += '&Keyword=' + keyword
        }
        if (mainCategoryId !== 0) {
            adr += '&CategoryId=' + mainCategoryId
        }
        const { data } = await axios.get(adr)
        if (data.status === "ok") {
            dispatch({
                type: ARTICELS_LIST_REQUEST_SUCCESS,
                payload: data.data
            })
        }
        else {
            dispatch({
                type: ARTICELS_LIST_REQUEST_FAIL,
                payload: 'خطا در دریافت اطلاعات از سرور'
            })
        }
    } catch (error) {
        const err = error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        console.error(err);
        dispatch({
            type: ARTICELS_LIST_REQUEST_FAIL,
            payload: 'خطا در دریافت اطلاعات از سرور'
        })
    }
}

export const articleDetail = (lang, id) => async (dispatch) => {
    try {
        dispatch({ type: ARTICEL_REQUEST })

        const { data } = await axios.get(`/api/articles/details?lan=${lang}&ArticleId=${id}`)
        if (data.status === "ok") {
            dispatch({
                type: ARTICEL_REQUEST_SUCCESS,
                payload: data.data
            })
        }
        else {
            dispatch({
                type: ARTICEL_REQUEST_FAIL,
                payload: 'خطا در دریافت اطلاعات از سرور'
            })
        }
    } catch (error) {
        const err = error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        console.error(err);
        dispatch({
            type: ARTICEL_REQUEST_FAIL,
            payload: 'خطا در دریافت اطلاعات از سرور'
        })
    }
}

export const adminArticleDetailAction = (id) => async (dispatch) => {
    const config = {
        headers: {
            Authorization: `Bearer ` + localStorage.getItem("token"),
            "Content-Type": "application/json",
        },
    };
    try {
        dispatch({ type: ADMIN_ARTICEL_REQUEST })

        const { data } = await axios.get(`/api/admin/articles/details?ArticleId=${id}`, config)
        if (data.status === "ok") {
            dispatch({
                type: ADMIN_ARTICEL_REQUEST_SUCCESS,
                payload: data.data
            })
        }
        else {
            dispatch({
                type: ADMIN_ARTICEL_REQUEST_FAIL,
                payload: 'خطا در دریافت اطلاعات از سرور'
            })
        }
    } catch (error) {
        const err = error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        console.error(err);
        dispatch({
            type: ADMIN_ARTICEL_REQUEST_FAIL,
            payload: 'خطا در دریافت اطلاعات از سرور'
        })
    }
}

